<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content">
  <div class="detail1-3">
    <div class="imgs">
      <img src="../../../../assets/images/compensate/netflix.webp" alt="" />
      <img src="../../../../assets/images/compensate/change.webp" alt="" />
      <span class="huiyuan">
        <img
          src="../../../../assets/images/compensate/huiyuan.webp"
          alt=""
          class="huiyuan"
        />钻石会员
      </span>
    </div>
    <div class="item">
      <span class="left">过期时间：</span>
      <span class="right"
        ><app-datetime [text]="data.ended_time"></app-datetime
      ></span>
    </div>
    <div class="item">
      <span class="left">剩余时间：</span
      ><span class="right">{{ data.remaining_days }}天</span>
    </div>
    <div class="item" style="color: #9f0000">
      <span class="left">转换时间：</span
      ><span class="right">{{ data.remaining_days + 60 }}天</span>
    </div>
    <div class="tip">温馨提示 ：</div>
    <div class="tip">
      借个号会员需要前往借个号官网使用，登入时请使用与环球巴士相同的手机号会员迁移会员1小时内完成，若登入账户无会员<span
        >请联系客服</span
      >
    </div>
    <div class="address" (click)="goto()">官网网址：jiegehao.cn</div>
  </div>
</div>
<div class="button">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="changeJiegehao()"
  >
    立即确认并转换
  </button>
</div>
